<template>
  <div>
    <md-field>
      <md-file v-model="file" @change="selectedFile" placeholder="Seleccionar archivo" />
    </md-field>
  </div>
</template>

<script>
export default {
  name: 'uploadFile',
  data () {
    return {
      file: null,
      selected: null
    }
  },
  methods: {
    selectedFile (f) {
      this.selected = f.srcElement.files[0]
      this.$emit('change', this.selected)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Providers/wizard/uploadFile.vue